import { useSyncExternalStore } from "react";

const DESKTOP_PANEL_MEDIA_QUERY = "(min-width: 1280px)";

function subscribe(onStoreChange: () => void) {
  const mediaQueryList = window.matchMedia(DESKTOP_PANEL_MEDIA_QUERY);
  mediaQueryList.addEventListener("change", onStoreChange);
  return () => mediaQueryList.removeEventListener("change", onStoreChange);
}

function getSnapshot() {
  return window.matchMedia(DESKTOP_PANEL_MEDIA_QUERY).matches;
}

function getServerSnapshot() {
  return false;
}

/**
 * 1280px 이상에서 Work History가 "좌측 표 + 우측 상세 panel"로 배치되는지 여부.
 * 그 미만(768~1279 포함)은 목록→bottom sheet 흐름을 쓴다 (TRD §7.5).
 *
 * 값이 바뀌어도 날짜 범위·선택 날짜·인력/장비 tab 상태는 이 훅과 무관하게
 * 호출부(DailyWorkList)에서 그대로 유지된다 — breakpoint 전환 시 controller가
 * 복제되거나 초기화되지 않는다.
 */
export function useIsWorkHistoryDesktopPanel(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
